import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["darkIcon", "lightIcon"]

  connect() {
    this.updateIcons()
  }

  toggle(event) {
    event.preventDefault()
    
    // Toggle dark mode
    if (localStorage.getItem('color-theme')) {
      if (localStorage.getItem('color-theme') === 'light') {
        document.documentElement.classList.add('dark')
        localStorage.setItem('color-theme', 'dark')
      } else {
        document.documentElement.classList.remove('dark')
        localStorage.setItem('color-theme', 'light')
      }
    } else {
      if (document.documentElement.classList.contains('dark')) {
        document.documentElement.classList.remove('dark')
        localStorage.setItem('color-theme', 'light')
      } else {
        document.documentElement.classList.add('dark')
        localStorage.setItem('color-theme', 'dark')
      }
    }

    this.updateIcons()
    
    // Dispatch a custom event for dark mode change
    document.documentElement.dispatchEvent(
      new CustomEvent('dark-mode-change', {
        detail: { isDark: document.documentElement.classList.contains('dark') }
      })
    )
  }

  updateIcons() {
    const isDark = document.documentElement.classList.contains('dark')
    this.darkIconTarget.classList.toggle('hidden', isDark)
    this.lightIconTarget.classList.toggle('hidden', !isDark)
  }
} 